/* eslint-disable @typescript-eslint/no-unused-vars */
import { AbstractControl, AsyncValidatorFn, ValidationErrors, ValidatorFn } from '@angular/forms';

import { IOfficeField } from '@pages/office/models/office-data.model';
import { NotificationsService } from '@core/services/notifications.service';
import { ControlCustomErrorsModel } from '@pages/office/office-form/office-form/form-controls/control-errors/models/control-custom-errors.model';

const DEFAULT_ERROR_MESSAGE = 'validate method must be implemented in a derived class';

export interface ControlValidatorRuntimeData {
  mode: string;
  field: IOfficeField;
  notificationService: NotificationsService;
}

export class ControlValidator {
  static readonly errorKey: string = DEFAULT_ERROR_MESSAGE;

  static validationErrors = (key: string, message: string): ControlCustomErrorsModel => {
    return { [key]: { message } };
  };
}

export abstract class IControlValidatorFieldValidatorFn extends ControlValidator {
  static validate(runtimeData: ControlValidatorRuntimeData): ValidatorFn {
    new Error(DEFAULT_ERROR_MESSAGE);
    return;
  }
}

export abstract class IControlAsyncValidatorFieldValidatorFn extends ControlValidator {
  static validate<T>(config?: T): AsyncValidatorFn {
    new Error(DEFAULT_ERROR_MESSAGE);
    return;
  }
}

export abstract class ControlValidatorValidationErrors extends ControlValidator {
  static validate(control: AbstractControl): ValidationErrors | null {
    throw new Error(DEFAULT_ERROR_MESSAGE);
  }
}
